//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'
import TableCell from 'components/Shared/TableNew/TableCell'

const MIN_WIDTH = 328
const StyledTableFormInputCell = styled(TableCell)`
  width: ${props => props.width || 'auto'};
  min-width: ${MIN_WIDTH}px;
  padding: 8px 16px 8px 8px;
`

const TableFormInputCell = ({ children, width }) => {
  return (
    <StyledTableFormInputCell width={width}>
      {children}
    </StyledTableFormInputCell>
  )
}

TableFormInputCell.propTypes = {
  children: PropTypes.node,
  width: PropTypes.string,
}

export default TableFormInputCell
